import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import { Tooltip as Mensaje } from "react-tooltip";
import { abrirBaseDeDatosLocal, eliminarResultados, puntosEstablecidos10CarrilesFecna, puntosEstablecidos8CarrilesFecna, puntosRelevosEstablecidos10CarrilesFecna, puntosRelevosEstablecidos8CarrilesFecna, traerResultados } from '../controllers/configuracionFirebase';
import { calcularPuntosWorldAquatics, pdfPruebaIndividual, pdfTiempos, revisarUrl } from '../controllers/pdfs';
import { Tooltip } from 'primereact/tooltip';
import { SpeedDial } from 'primereact/speeddial';
import { exportTiempos, tiemposToHy3 } from '../controllers/xlsx';
import { arreglarTiempoEstandar } from '../controllers/pdfs';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { datosAdmin, departamentosColombia, gruposCategorias } from '../controllers/administrador';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import Finales from './Finales';
import { ToggleButton } from 'primereact/togglebutton';
import { Tag } from 'primereact/tag';
import Swal from 'sweetalert2';
import { Avatar } from 'primereact/avatar';

const ResultadosTiempos = ({ 
  resultados, 
  infoUsuario, 
  setResultados, 
  idTorneoParticipando,
  torneoEspecifico,
  listPruebas,
  listadoCategorias }) => {

  const [ animateList, setAnimateList ] = useState(false);
  const [ dejarAnimateList, setDejarAnimateList ] = useState(true);
  const [ conexion, setConexion ] = useState(true);
  const [ dialogHistorial, setDialogHistorial ] = useState(false);
  const [ historialDeportista, setHistorialDeportista ] = useState();
  const [ visibleCount, setVisibleCount ] = useState(1);
  const [ globalFilter, setGlobalFilter ] = useState('');
  const [ cantPuestos, setCantPuestos ] = useState('');
  const [ pdfUrl, setPdfUrl ] = useState();
  const [ deportistasMasCompletos, setDeportistasMasCompletos ] = useState([]);
  const [ seriesSeparadas, setSeriesSeparadas ] = useState([]);
  const resultadosRef = React.useRef(resultados);

  function manejoRendimiento(record, tiempo){
    if(tiempo && record && record !== '0:0:0' && tiempo !== '0:0:0'){
      const dividirTiempoA = record.split(':');
      const dividirTiempoB = tiempo.split(':');
      const tiempoMinA = dividirTiempoA[0];
      const tiempoSegA = dividirTiempoA[1];
      const tiempoMiliA = dividirTiempoA[2];
      const tiempoMinB = dividirTiempoB[0];
      const tiempoSegB = dividirTiempoB[1];
      const tiempoMiliB = dividirTiempoB[2];
      const tiempoA = parseInt(tiempoMinA) * 60 * 1000 + parseInt(tiempoSegA) * 1000 + parseInt(tiempoMiliA);
      const tiempoB = parseInt(tiempoMinB) * 60 * 1000 + parseInt(tiempoSegB) * 1000 + parseInt(tiempoMiliB);

      const resultadoRecords = parseFloat((tiempoA - tiempoB));
      
      return resultadoRecords;
    }else{
      return 0;
    }
  }

  function arreglarFormatoTiempo(resultadoRecords){
    const auxResultadoRecords = Math.abs(resultadoRecords);
    const minutos = Math.floor(auxResultadoRecords / (60 * 1000));
    const segundos = Math.floor((auxResultadoRecords % (60 * 1000)) / 1000);
    const milisegundos = auxResultadoRecords % 1000;
    if(minutos !== 0){
      return minutos + ':' + segundos + '.' + milisegundos;
    }else{
      return segundos + '.' + milisegundos;
    }
  }

  async function sacarHistorialDeportista(nad){
    setDialogHistorial(true);
    const auxHistorial = [];
    if(await revisarUrl(nad.urlPhoto)){
      nad.urlPhoto = nad.urlPhoto;
    }else{
      nad.urlPhoto = '';
    }
    if(await revisarUrl(nad.urlPhotoEq)){
      nad.urlPhotoEq = nad.urlPhotoEq;
    }else{
      nad.urlPhotoEq = require('../img/img-logo-swimmingt.webp');
    }
    resultados.forEach((result)=>{
      const objHistorial = {};
      result.nadadores.forEach((nadad)=>{
        if(nadad.identificacion === nad.identificacion && !nadad.equipo){
          objHistorial.puesto = nadad.tiempo !== '61:0:0' ? nadad.tiempo !== '0:0:0' ? nadad.posicion : 'NSP' : 'DSC';
          objHistorial.nPrueba = result.id + 1;
          objHistorial.prueba = result.prueba.prueba;
          objHistorial.record = nadad.equipo === null ? nadad.record !== '' ? nadad.record : '0:0:0' : '0:0:0';
          objHistorial.tiempo = nadad.tiempo;
          objHistorial.puntos = result.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 0 : parseInt(torneoEspecifico.carril) <= 8 ? puntosEstablecidos8CarrilesFecna(0, nadad.posicion - 1) : puntosEstablecidos10CarrilesFecna(0, nadad.posicion - 1);
          objHistorial.puntosWA = calcularPuntosWorldAquatics(nadad.tiempo, nadad.genero, result.prueba.prueba, torneoEspecifico.piscina);
          objHistorial.verificado = nadad.verificado;
          auxHistorial.push(objHistorial);
        }

        if(nadad.equipo){
          const auxNombre = nadad.equipo.filter((eq) => {return eq === nad.nombre});
          if(auxNombre.length !== 0){
            objHistorial.puesto = nadad.tiempo !== '61:0:0' ? nadad.tiempo !== '0:0:0' ? nadad.posicion : 'NSP' : 'DSC';
            objHistorial.nPrueba = result.id + 1;
            objHistorial.prueba = result.prueba.prueba;
            objHistorial.record = nadad.equipo === null ? nadad.record !== '' ? nadad.record : '0:0:0' : '0:0:0';
            objHistorial.tiempo = nadad.tiempo;
            objHistorial.puntos = result.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 0 : parseInt(torneoEspecifico.carril) <= 8 ? puntosRelevosEstablecidos8CarrilesFecna(0, nadad.posicion - 1) : puntosRelevosEstablecidos10CarrilesFecna(0, nadad.posicion - 1);
            objHistorial.puntosWA = '0';
            auxHistorial.push(objHistorial);
          }
        }
      })
    })
    nad.pruebas = [...auxHistorial];
    setHistorialDeportista(nad);
  }

  const items = [
    {
      label: 'Tiempos .hy3',
      icon: 'pi pi-file',
      command: () => tiemposToHy3(resultados, torneoEspecifico)
    },
    {
      label: 'Tiempos .xlsx',
      icon: 'pi pi-file-excel',
      command: () => exportTiempos(resultados)
    },
    {
      label: 'Tiempos .pdf',
      icon: 'pi pi-file-pdf',
      command: () => pdfTiempos(resultados, setPdfUrl, torneoEspecifico, infoUsuario, globalFilter, cantPuestos)
    },
  ];

  function banderas(departamento, codePais){
    const buscarBandera = departamentosColombia.filter((depBan) => {return depBan.dep === (departamento ? departamento : 'Colombia')});
    const banderaPais = departamentosColombia.filter((depBan) => {return depBan.codePais === (codePais ? codePais : 'Colombia') && depBan.pais});
    if(buscarBandera.length !== 0){
      return <div className="position-relative m-auto" style={{width: '35px'}}>
        <img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={buscarBandera[0].bandera} alt='Bandera'/>
        {banderaPais[0]?.bandera ? <img className="position-absolute bottom-0 end-0 border" style={{width: '18px'}} src={banderaPais[0]?.bandera} alt='Bandera'/> : <></>}
      </div>
    }
  }

  function validarDesicionEliminacion(idTorneo, idResultados){
    const alerta = Swal.mixin({
      toast: true,
      showCancelButton: true
    })
    alerta.fire({
      html: `<div class="w-100 position-relative">
      <img style="width: 100px; position: absolute; top: 10px; right: 0; z-index: -10" src="${require('../img/img-logo-swimmingt.webp')}" />
      <p style="z-index: 10; font-family: Poppins" class="mb-0">¿Esta seguro de eliminar los resultados?
      </div>`,
      confirmButtonText: 'Confirmar',
      confirmButtonColor: 'rgb(248, 18, 18)',
      padding: 4,
      cancelButtonText: 'Cancelar',
    }).then((respuesta) =>{ 
      if(respuesta.isConfirmed){
        eliminarResultados(idTorneo, idResultados);
      }
    })
  }

  useEffect(() => {
    // Comparamos los arreglos anterior y actual para detectar cambios de posición
    if (JSON.stringify(resultadosRef.current) !== JSON.stringify(resultados)) {
      // Si hay una diferencia en los arreglos, activamos la animación
      if(dejarAnimateList){
        setAnimateList(true);
      }
    }

    function buscarGrupoPorEdad(edad, genero) {
      return gruposCategorias.find(grupo => grupo.edades.includes(edad) && grupo.genero === genero);
    }

    function deportistasCompletos(){
      const auxResultados = JSON.parse(JSON.stringify(resultados));
      const auxGruposCategorias = gruposCategorias.map(grupo => {
        return {
          categoria: grupo.categoria,
          genero: grupo.genero,
          nadadores: []
        };
      });
      
      for (const resultado of auxResultados) {
        const prueba = resultado.prueba.prueba;

        for (const nadador of resultado.nadadores) {
          if(!nadador.equipo){
            // Buscamos a qué grupo pertenece
            const grupo = buscarGrupoPorEdad(parseInt(nadador.edad), nadador.genero);
            if (!grupo) continue;
          
            // Buscamos el grupo en el nuevo arreglo
            const grupoDestino = auxGruposCategorias.find(g => g.categoria === grupo.categoria && g.genero === grupo.genero);
          
            // Verificamos si el nadador ya fue agregado
            let nadadorExistente = grupoDestino.nadadores.find(n => n.nombre === nadador.nombre && n.edad === nadador.edad && n.genero === nadador.genero);
            
            if (!nadadorExistente) {
              // Si no está, lo agregamos con la prueba
              nadadorExistente = {
                nombre: nadador.nombre,
                edad: nadador.edad,
                genero: nadador.genero,
                departamento: nadador.departamento,
                codePais: nadador.codePais,
                nombreclub: nadador.nombreclub,
                categoria: resultado.categoria,
                grupo: grupoDestino.categoria,
                urlPhoto: nadador.urlPhoto,
                pruebas: [],
                puntos: 0
              };
              grupoDestino.nadadores.push(nadadorExistente);
            }
  
            
            // Agregamos la prueba que hizo
            nadadorExistente.pruebas.push({
              id: resultado.id + 1,
              prueba,
              tiempo: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.tiempo,
              posicion: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.posicion,
              puntosPosicion: resultado.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 0 : parseInt(torneoEspecifico.carril) <= 8 ? parseInt(puntosEstablecidos8CarrilesFecna(0, nadador.posicion - 1)) : parseInt(puntosEstablecidos10CarrilesFecna(0, nadador.posicion - 1)),
              puntosWA: calcularPuntosWorldAquatics(nadador.tiempo, nadador.genero, resultado.prueba.prueba, torneoEspecifico.piscina),
              puntosNSP: nadador.tiempo === '0:0:0' ? -5 : 3,
              puntosDSC: nadador.tiempo === '61:0:0' ? -10 : 3,
              puntosPrimerLugar: nadador.posicion === 1 ? 5 : 0,
              puntos: 0
            });
  
            nadadorExistente.pruebas.forEach((nadExi)=>{
              nadExi.puntos = nadExi.puntosPosicion + nadExi.puntosWA + nadExi.puntosPrimerLugar + nadExi.puntosNSP + nadExi.puntosDSC;
            })
          }else{
            for(const eq of nadador.equipo){
              let auxDeportista = null;
              auxResultados.forEach((resul)=>{
                resul.nadadores.forEach((nad)=>{
                  if(eq === nad.nombre && !nad.equipo && nad.nombreclub === nadador.nombreclub){
                    auxDeportista = nad;
                  }
                })
              })

              if(auxDeportista){
                // Buscamos a qué grupo pertenece
                const grupo = buscarGrupoPorEdad(parseInt(auxDeportista.edad), auxDeportista.genero);
                if (!grupo) continue;
            
                // Buscamos el grupo en el nuevo arreglo
                const grupoDestino = auxGruposCategorias.find(g => g.categoria === grupo.categoria && g.genero === grupo.genero);
            
                // Verificamos si el nadador ya fue agregado
                let nadadorExistente = grupoDestino.nadadores.find(n => n.nombre === auxDeportista.nombre && n.edad === auxDeportista.edad && n.genero === auxDeportista.genero);
              
                if (!nadadorExistente) {
                  // Si no está, lo agregamos con la prueba
                  nadadorExistente = {
                    nombre: auxDeportista.nombre,
                    edad: auxDeportista.edad,
                    genero: auxDeportista.genero,
                    departamento: nadador.departamento,
                    codePais: nadador.codePais,
                    nombreclub: nadador.nombreclub,
                    categoria: resultado.categoria,
                    grupo: grupoDestino.categoria,
                    urlPhoto: nadador.urlPhoto,
                    pruebas: [],
                    puntos: 0
                  };
                  grupoDestino.nadadores.push(nadadorExistente);
                }
    
              
                // Agregamos la prueba que hizo
                nadadorExistente.pruebas.push({
                  id: resultado.id + 1,
                  prueba,
                  tiempo: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.tiempo,
                  posicion: nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : nadador.posicion,
                  puntosPosicion: resultado.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 0 : parseInt(torneoEspecifico.carril) <= 8 ? parseInt(puntosEstablecidos8CarrilesFecna(0, nadador.posicion - 1)) : parseInt(puntosEstablecidos10CarrilesFecna(0, nadador.posicion - 1)),
                  puntosWA: calcularPuntosWorldAquatics(nadador.tiempo, auxDeportista.genero, resultado.prueba.prueba, torneoEspecifico.piscina),
                  puntosNSP: nadador.tiempo === '0:0:0' ? -5 : 3,
                  puntosDSC: nadador.tiempo === '61:0:0' ? -10 : 3,
                  puntosPrimerLugar: nadador.posicion === 1 ? 5 : 0,
                  puntos: 0
                });
    
                nadadorExistente.pruebas.forEach((nadExi)=>{
                  nadExi.puntos = nadExi.puntosPosicion + nadExi.puntosWA + nadExi.puntosPrimerLugar + nadExi.puntosNSP + nadExi.puntosDSC;
                })
              }
            }
          }
        }
      }
      auxGruposCategorias.forEach((gru)=>{
        gru.nadadores.forEach((nad)=>{
          nad.pruebas.forEach((prue)=>{
            nad.puntos += prue.puntos;
          })
        })
      })
      auxGruposCategorias.map((gru)=>gru.nadadores.sort((a,b)=> b.puntos - a.puntos));
      setDeportistasMasCompletos(auxGruposCategorias);
    }

    function separareries(){
      const auxResultadosSeries = [];
      resultados.forEach((result)=>{
        const pruebas = {
          categoria: result.categoria,
          categoriaDeportistas: result.categoriaDeportistas,
          categoriaEdad: result.categoriaEdad,
          id: result.id,
          prueba: result.prueba,
          series: []
        };
        const auxSeries = [];
        result.nadadores.forEach((nad)=>{
          auxSeries[parseInt(nad.serie - 1)] = [];
        })

        result.nadadores.forEach((nad)=>{
          auxSeries[parseInt(nad.serie - 1)].push(nad);
        })

        pruebas.series = auxSeries;
        auxResultadosSeries.push(pruebas);
      })
      
      setSeriesSeparadas(auxResultadosSeries);
    }

    deportistasCompletos();
    separareries();
    // Actualizamos la referencia con el nuevo estado del arreglo
    resultadosRef.current = resultados;

    const animationDuration = 1000; // Duración de la animación en milisegundos (aquí 0.5 segundos)
    const timer = setTimeout(() => {
      setAnimateList(false);
    }, animationDuration);
 
    return () => clearTimeout(timer);
  }, [resultadosRef, resultados])

  useEffect(() => {
    traerResultados(idTorneoParticipando, setResultados, setConexion, infoUsuario.nombreclub);
  }, [infoUsuario])

  useEffect(() => {
    if(infoUsuario.nombreclub === datosAdmin.nombre || infoUsuario.nombreclub === 'PROWEBSPORTS'){
      abrirBaseDeDatosLocal(idTorneoParticipando);
    }
  },[infoUsuario])

  useEffect(() => {
    if (visibleCount < resultados.length) {
      const timeout = setTimeout(() => setVisibleCount(v => v + 10), 500);
      return () => clearTimeout(timeout);
    }
  }, [visibleCount, resultados.length]);

  return (
    <div className='position-relative'>
      {infoUsuario.nombreclub === datosAdmin.nombre || infoUsuario.nombreclub === 'PROWEBSPORTS'?(
        <>
          {!conexion ? <>
            <button className='btn btn-secondary ms-1 mt-2 shadow' id='sininternet' onClick={() => traerResultados(idTorneoParticipando, setResultados, setConexion, infoUsuario.nombreclub)}>{'Actualizar Resultados'}</button>
          </>
          :
          <></>
          }
        </>
      ):(
        <></>
      )}
      <TabView scrollable>
        <TabPanel header="Puestos" leftIcon='pi pi-list-check me-2'>
          <div className="d-flex flex-wrap justify-content-center align-items-center bg-light pt-2 pb-2">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                  type="number"
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  placeholder="Numero de prueba"
                />
            </span>
            <span className="p-input-icon-left">
                <i className="pi pi-list" />
                <InputText
                  type="number"
                  onChange={(e) => setCantPuestos(e.target.value)}
                  placeholder="Cantidad Puestos"
                />
            </span>
            {infoUsuario.nombreclub === datosAdmin.nombre || infoUsuario.nombreclub === 'PROWEBSPORTS' ?(
              <ToggleButton onLabel='Animación' offLabel='Animación' onIcon="pi pi-check" offIcon="pi pi-times" onChange={(e) => setDejarAnimateList(e.value)} checked={dejarAnimateList} />
            ):(
              <></>
            )}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '10px'}}>
            {resultados.length !== 0 ?(
              resultados.filter((resu)=>((resu.id + 1) + '').includes(globalFilter)).slice(0, visibleCount).map((result, indexResult)=>{
                return <form key={indexResult} className='formulario-tablas table-responsive-sm'>
                <motion.table style={{margin: '4px', width: '530px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{duration: 1}}
                className='shadow tabla-tiempos'
                >
                  <thead className='text-light'>
                    <tr style={{borderBottom: '1px solid white'}}>
                      <td style={{fontSize: '16px', fontFamily: 'Fira Sans Extra Condensed'}} colSpan={9}>
                        {resultados.length - 1 === indexResult ?(
                          <span className='d-flex justify-content-between aling-items-center'>
                            <div className='ms-1'>
                              <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingD${indexResult}`} severity="danger" rounded value='' className='border border-dark' style={{width: '1rem', height: '1rem'}}></Tag>
                            </div>
                            {result.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 'No Acumula Para El Trofeo - ' : ''} En Curso...
                            <i className='d-flex align-items-center pi pi-external-link btn btn-primary me-1' data-bs-toggle="modal" data-bs-target="#staticBackdrop1"></i>
                          </span>
                        ):(
                          <div className='d-flex justify-content-between aling-items-center'>
                            <div className='ms-1 mb-1'>
                              <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingD${indexResult}`} severity="danger" rounded value='' className='border border-dark' style={{width: '1rem', height: '1rem'}}></Tag>
                            </div>
                            <span className='me-2 pt-1'>
                              {result.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 'No Acumula Para El Trofeo - ' : ''} Terminada ✔
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr style={{borderBottom: '1px solid white'}}>
                      <th className='id fs-4'>{result.id + 1}</th>
                      <th style={{fontSize: '18px', borderLeft: '1px solid white'}} colSpan={5}>{result.categoria}</th>
                      {infoUsuario.nombreclub === "PROWEBSPORTS" ? (
                        <th><i title='Eliminar' className='pi pi-times me-1 text-danger' style={{cursor: 'pointer'}} onClick={() => validarDesicionEliminacion(idTorneoParticipando, result.id)}></i></th>
                      ):(
                        <></>
                      )}
                    </tr>
                    <tr style={{borderBottom: '1px solid white'}}>
                      <th style={{fontSize: '18px'}} colSpan={6}>{result.prueba.prueba}</th>
                      <th><Button type='button' icon='pi pi-file-pdf' text severity='danger' onClick={() => pdfPruebaIndividual(result, torneoEspecifico, setPdfUrl)} style={{borderRadius: '10px', padding: '2px 0'}}/></th>
                    </tr>
                    <tr>
                      <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Psto</th>
                      <th style={{width: '50px', fontSize: '15px', borderRight: '1px solid white'}}>Ln-Sr</th>
                      <th colSpan={2} style={{fontSize: '15px', borderRight: '1px solid white'}}>Deportista</th>
                      <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Tiempo</th>
                      <th style={{fontSize: '15px', borderRight: '1px solid white'}}>W.A</th>
                      <th style={{fontSize: '15px'}}><img style={{width: '30px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    {result.nadadores.slice(0, cantPuestos === '' ? result.nadadores.length : cantPuestos).map((nadador, indexNadador)=>{
                      return <motion.tr key={indexNadador}
                      initial={{ x: -1000, opacity: 0}}
                      animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                      style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexNadador}`}}
                      transition={{ duration: 1, delay: `0.${indexNadador}`, type: 'spring'}}
                      >
                        {nadador.posicion === 1 ? <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></td> : nadador.posicion === 2 ? <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /></td> :  nadador.posicion === 3 ? <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /></td> : <td className={`pt-2 pb-2 ${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}>{nadador.posicion !== 9999 ? nadador.posicion : '-'}</td>}
                        <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{nadador.carril + '-' + nadador.serie}</td>
                        <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{banderas(nadador.departamento, nadador.codePais)}</td>
                        {nadador.equipo !== null ?(
                          <td className={`text-start ${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>
                            {nadador.equipo.map((eq, indexEq)=>{
                              return <span key={indexEq}>{eq} <hr className='m-0'/></span>
                            })}
                            <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                          </td> 
                          ):(
                          <td className={`text-start ${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}} onClick={() => sacarHistorialDeportista(nadador)}><label className="d-flex flex-column">
                            <label style={{cursor: 'pointer'}}>{nadador.nombre + ' '} {nadador?.verificado === 'Verificado' ? <i title='Verificado' className='pi pi-verified text-primary bg-info rounded-circle'></i> : ''}</label>
                            <label className="text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                          </label></td>
                        )}
                        <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-tiempos text-light' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light' : 'bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}>{nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : <label className="w-100 fw-bold d-flex flex-column text-end"><li style={{fontSize: '13px'}} className={manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo) >= 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</li>{arreglarTiempoEstandar(nadador.tiempo)}</label>}</td>
                        <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light fw-bold' : 'fw-bold'}`} style={{fontSize: '13px', fontFamily: 'Poppins', background: 'white'}}>{calcularPuntosWorldAquatics(nadador.tiempo, nadador.genero, result.prueba.prueba, torneoEspecifico.piscina)}</td>
                        <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-tiempos text-light fw-bold' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light fw-bold' : 'bg-tiempos text-light fw-bold'}`} style={{fontSize: '13px', fontFamily: 'Poppins', borderRadius: '0 0 20px 0'}}>{arreglarFormatoTiempo(manejoRendimiento(result.nadadores[0].tiempo, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</td>
                      </motion.tr>
                    })}
                  </tbody>
                </motion.table>
              </form> 
              }) 
            ):(
              <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{duration: 1}}
              className='w-75 m-auto bg-light'
              style={{borderRadius: '10px'}}
              >
                <div className='p-5'>
                  <img className='w-25' src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                  <h1>¡Bienvenido!</h1>
                  <p>No tenemos registros de tiempos aún.</p>
                </div>
              </motion.div>
            )}
          </div>
        </TabPanel>
        <TabPanel header="Series" leftIcon='pi pi-arrow-right-arrow-left me-2'>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
            {resultados.length !== 0 && seriesSeparadas.length !== 0 ?(
              resultados.map((result, indexResult)=>{
                return <form key={indexResult} className='formulario-tablas table-responsive-sm'>
                <motion.table style={{margin: '4px', width: '530px', borderRadius: '20px 0', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{duration: 1}}
                className='shadow tabla-tiempos'
                >
                  <thead className='text-light'>
                    <tr style={{borderBottom: '1px solid white'}}>
                      <td style={{fontSize: '16px', fontFamily: 'Fira Sans Extra Condensed'}} colSpan={9}>
                        {resultados.length - 1 === indexResult ?(
                          <span className='d-flex justify-content-between aling-items-center'>
                            <div className='ms-1'>
                              <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingD${indexResult}`} severity="danger" rounded className='border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                            </div>
                            {result.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 'No Acumula Para El Trofeo - ' : ''} En Curso...
                            <i className='d-flex align-items-center pi pi-external-link btn btn-primary me-1' data-bs-toggle="modal" data-bs-target="#staticBackdrop1"></i>
                          </span>
                        ):(
                          <div className='d-flex justify-content-between aling-items-center'>
                            <div className='ms-1 mb-1'>
                              <Tag id={`#01ranking${indexResult}`} rounded className='me-1 bg-warning border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingN${indexResult}`} severity="success" rounded className='me-1 border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                              <Tag id={`rankingD${indexResult}`} severity="danger" rounded className='border border-dark' value='' style={{width: '1rem', height: '1rem'}}></Tag>
                            </div>
                            <span className='me-2 pt-1'>
                              {result.nadadores.length === 1 && torneoEspecifico.puntuacion === 'no' ? 'No Acumula Para El Trofeo - ' : ''} Terminada ✔
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr style={{borderBottom: '1px solid white'}}>
                      <th className='id fs-4'>{result.id + 1}</th>
                      <th style={{fontSize: '18px', borderLeft: '1px solid white'}} colSpan={6}>{result.categoria}</th>
                    </tr>
                    <tr style={{borderBottom: '1px solid white'}}>
                      <th style={{fontSize: '18px'}} colSpan={7}>{result.prueba.prueba}</th>
                    </tr>
                    <tr>
                      <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Psto</th>
                      <th style={{width: '50px', fontSize: '15px', borderRight: '1px solid white'}}>Ln-Sr</th>
                      <th colSpan={2} style={{fontSize: '15px', borderRight: '1px solid white'}}>Deportista</th>
                      <th style={{fontSize: '15px', borderRight: '1px solid white'}}>Tiempo</th>
                      <th style={{fontSize: '15px', borderRight: '1px solid white'}}>W.A</th>
                      <th style={{fontSize: '15px'}}><img style={{width: '30px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></th>
                    </tr>
                  </thead>
                  {(seriesSeparadas[indexResult] && seriesSeparadas[indexResult].series.length !== 0) ?(
                    seriesSeparadas[indexResult].series.map((serie, indexSerie)=>{
                      return <tbody key={indexSerie}>
                        <tr className='bg-tiempos' style={{borderBottom: '1px solid white', borderTop: '1px solid white'}}>
                          <th colSpan={7} className='text-light text-start' style={{fontSize: '16px', borderRight: '1px solid white'}}>Serie #{indexSerie + 1}</th>
                        </tr>
                        {serie.slice(0, cantPuestos === '' ? serie.length : cantPuestos).map((nadador, indexNadador)=>{
                          return <motion.tr key={indexNadador}
                          initial={{ x: -1000, opacity: 0}}
                          animate={{ x: animateList ? -1000 : 0.1, opacity: animateList ? 0 : 1}}
                          style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexNadador}`}}
                          transition={{ duration: 1, delay: `0.${indexNadador}`, type: 'spring'}}
                          >
                            {nadador.posicion === 1 ? <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></td> : nadador.posicion === 2 ? <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /></td> :  nadador.posicion === 3 ? <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}><img style={{width: '35px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /></td> : <td className={`pt-2 pb-2 ${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white', borderRadius: '20px 0 0 0'}}>{nadador.posicion !== 9999 ? nadador.posicion : '-'}</td>}
                            <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{nadador.carril + '-' + nadador.serie}</td>
                            <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>{banderas(nadador.departamento, nadador.codePais)}</td>
                            {nadador.equipo !== null ?(
                              <td className={`text-start ${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}}>
                                {nadador.equipo.map((eq, indexEq)=>{
                                  return <span key={indexEq}>{eq} <hr className='m-0'/></span>
                                })}
                                <label className="w-100 text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                              </td> 
                              ):(
                              <td className={`text-start ${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light' : ''}`} style={{fontSize: '14px', fontFamily: 'Poppins', background: 'white'}} onClick={() => sacarHistorialDeportista(nadador)}><label className="d-flex flex-column">
                                <label style={{cursor: 'pointer'}}>{nadador.nombre + ' '} {nadador?.verificado === 'Verificado' ? <i title='Verificado' className='pi pi-verified text-primary bg-info rounded-circle'></i> : ''} {nadador.rankingNacional === 1 && nadador.rankingDepartamental === 1 ? <i title='#01 Ranking Nac. Y Dep.' className='pi pi-crown text-warning fs-5'></i> : ''}{nadador.rankingNacional ? nadador.rankingNacional === 1 && nadador.rankingDepartamental !== 1 ? <Tag title='Puesto Ranking Nacional' severity="success" value={nadador.rankingNacional < 10 ? '0' + nadador.rankingNacional : nadador.rankingNacional} style={{fontSize: '0.8rem', padding: '0rem 0.1rem', display: 'inline'}}></Tag> : nadador.rankingNacional !== 1 ? <Tag title='Puesto Ranking Nacional' severity="success" value={nadador.rankingNacional < 10 ? '0' + nadador.rankingNacional : nadador.rankingNacional} style={{fontSize: '0.8rem', padding: '0rem 0.1rem', display: 'inline'}}></Tag> : '' : ''}{' '}{nadador.rankingDepartamental ? nadador.rankingNacional !== 1 && nadador.rankingDepartamental === 1 ? <Tag title='Puesto Ranking Departamental' severity="danger" value={nadador.rankingDepartamental < 10 ? '0' + nadador.rankingDepartamental : nadador.rankingDepartamental} style={{fontSize: '0.8rem', padding: '0rem 0.1rem', display: 'inline'}}></Tag> : nadador.rankingDepartamental !== 1 ? <Tag title='Puesto Ranking Departamental' severity="danger" value={nadador.rankingDepartamental < 10 ? '0' + nadador.rankingDepartamental : nadador.rankingDepartamental} style={{fontSize: '0.8rem', padding: '0rem 0.1rem', display: 'inline'}}></Tag> : '' : ''}</label>
                                <label className="text-end fw-bold" style={{fontSize: "11px"}}>{nadador.nombreclub}</label>
                              </label></td>
                            )}
                            <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-tiempos text-light' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light' : 'bg-tiempos text-light'}`} style={{fontSize: '15px', fontFamily: 'Poppins'}}>{nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : <label className="w-100 fw-bold d-flex flex-column text-end"><li style={{fontSize: '13px'}} className={manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo) >= 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(manejoRendimiento(nadador.record, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</li>{arreglarTiempoEstandar(nadador.tiempo)}</label>}</td>
                            <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-info bg-gradient text-light fw-bold' : 'fw-bold'}`} style={{fontSize: '13px', fontFamily: 'Poppins', background: 'white'}}>{calcularPuntosWorldAquatics(nadador.tiempo, nadador.genero, result.prueba.prueba, torneoEspecifico.piscina)}</td>
                            <td className={`${infoUsuario.nombreclub === nadador.nombreclub ? 'bg-tiempos text-light fw-bold' : (nadador.tiempo === '0:0:0' || nadador.tiempo === '61:0:0') ? 'bg-danger text-light fw-bold' : 'bg-tiempos text-light fw-bold'}`} style={{fontSize: '13px', fontFamily: 'Poppins', borderRadius: '0 0 20px 0'}}>{arreglarFormatoTiempo(manejoRendimiento(result.nadadores[0].tiempo, nadador.tiempo === '61:0:0' ? '0:0:0' : nadador.tiempo))}</td>
                          </motion.tr>
                        })}
                      </tbody>
                    })
                  ):(
                    <></>
                  )}
                </motion.table>
                <Mensaje
                  anchorId={`#01ranking${indexResult}`}
                  place="bottom"
                  content={'#01 Ranking Nac. Y Dep.'}
                  className="bg-warning text-dark"
                  style={{ zIndex: 1}}
                />
                <Mensaje
                  anchorId={`rankingN${indexResult}`}
                  place="bottom"
                  content={'Ranking Nacional'}
                  className="bg-success"
                  style={{ zIndex: 1}}
                />
                <Mensaje
                  anchorId={`rankingD${indexResult}`}
                  place="bottom"
                  content={'Ranking Departamental'}
                  className="bg-danger"
                  style={{ zIndex: 1}}
                />
              </form> 
              }) 
            ):(
              <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{duration: 1}}
              className='w-75 m-auto bg-light'
              style={{borderRadius: '10px'}}
              >
                <div className='p-5'>
                  <img className='w-25' src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                  <h1>¡Bienvenido!</h1>
                  <p>No tenemos registros de tiempos aún.</p>
                </div>
              </motion.div>
            )}
          </div>
        </TabPanel>
        {torneoEspecifico.idFinales !== '' ?(
          <TabPanel header="Finalistas" leftIcon='pi pi-sitemap me-2'>
            <Finales
              resultados={resultados}
              torneoEspecifico={torneoEspecifico}
              idTorneoParticipando={idTorneoParticipando}
              infoUsuario={infoUsuario}
              listPruebas={listPruebas}
              listadoCategorias={listadoCategorias}/>
          </TabPanel>
        ):(
          <></>
        )}
        <TabPanel header="Top Deportistas" leftIcon='pi pi-crown me-2'>
          <div className="alert alert-info alert-dismissible fade show text-start mb-0" role="alert">
            <h4>El Deportista Más Completo</h4>
            <p className="mb-0">Suma puntos por posición según World Aquatics, más puntos por rendimiento técnico y bonificación por primer lugar. Pierde puntos si no se presenta (NSP) o es descalificado (DSC).</p>
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
          <div className='w-100 m-auto flex-fill row row-cols-1 row-cols-sm-2 row-cols-md-4 justify-content-center align-items-start'>
            {deportistasMasCompletos.length !== 0 ? (
              deportistasMasCompletos.map((depor, indexDepor)=>{
                return depor.nadadores.length !== 0 ?(
                  <motion.div
                    className={`position-relative card m-2 pt-2 col shadow card-torneo card-crear-torneo`}
                    style={{ width: "22rem", background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)' }}
                    key={indexDepor} 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: `0.${indexDepor}5` }}
                    id={`card-torneo${indexDepor}`}
                  >
                    <div className="w-100">
                      <div className='d-flex'>
                        <div>
                          {banderas(depor.nadadores[0]?.departamento, depor.nadadores[0]?.codePais)}
                        </div>
                        <p className='m-0 ms-2' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.nadadores[0]?.departamento}</p>
                      </div>
                      <div className='bg-light rounded-3 shadow px-1 position-relative'>
                        <img className='position-absolute' src={depor.nadadores[0]?.urlPhoto && depor.nadadores[0]?.urlPhoto !== '' ? depor.nadadores[0].urlPhoto : depor.nadadores[0].genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{width: '70px', filter: 'drop-shadow(0 0 2px black) drop-shadow(0 0 1px white)', bottom: '0', right: '0'}}/>
                        <h4 className='card-title mt-1 mb-0 text-start'>{depor.nadadores[0]?.nombre}</h4>
                        <p className='m-0 text-start'>{depor.nadadores[0]?.edad + ' Años'}</p>
                      </div>
                      <p className='m-0 text-start' style={{color: 'rgba(212, 212, 212, 1)'}}>{depor.nadadores[0]?.nombreclub}</p>
                      <hr className='m-0 text-light'/>
                      <h5 className='card-subtitle my-1 text-light'>{depor.nadadores[0]?.grupo + ' - ' + depor.nadadores[0]?.categoria}</h5>
                      <hr className='m-0 text-light'/>
                      {depor.nadadores[0]?.pruebas.length !== 0 ?(
                        depor.nadadores[0]?.pruebas.map((prue, indexPrue)=>{
                          return <div key={indexPrue}>
                            <div className='d-flex justify-content-center align-items-center' data-bs-toggle="collapse" href={`#collapseExample${indexPrue}${Math.round(prue.id)}`} role='button' aria-expanded="false" aria-controls={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                              <div>
                                <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{'Prueba #' + (prue.id + 1) + ' - ' + prue.prueba}</p>
                                <p className='m-0 text-light'>{'Puesto #' + prue.posicion + ' - ' + prue.tiempo}</p>
                              </div>
                              <i className='pi pi-angle-down text-light'></i>
                            </div>
                            <hr className='m-0 text-light'/>
                            <div className='collapse' id={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>World Aquatics:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosPosicion > 0  ? '+' : '') + prue.puntosPosicion}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Primer Puesto:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosPrimerLugar > 0  ? '+' : '') + prue.puntosPrimerLugar}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Rendimiento Técnico:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosWA > 0  ? '+' : '') + prue.puntosWA}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>NSP:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosNSP > 0  ? '+' : '') + prue.puntosNSP}</p>
                              </div>
                              <hr className='m-0 text-light'/>
                              <div className='d-flex justify-content-between'>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>DSC:</p>
                                <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{(prue.puntosDSC > 0  ? '+' : '') + prue.puntosDSC}</p>
                              </div>
                            </div>
                            <hr className='m-0 text-light'/>
                            <div className='d-flex justify-content-between bg-light shadow px-1'>
                              <p className='m-0 text-end fw-bold'>Puntos:</p>
                              <p className='m-0 text-end fw-bold'>{(prue.puntos > 0  ? '+' : '') + prue.puntos.toFixed(2)}</p>
                            </div>
                            <hr className='m-0 text-light'/>
                          </div>
                        })
                      ):(
                        <></>
                      )}
                      <hr className='m-0'/>
                      <div className='d-flex justify-content-between bg-light shadow mb-2 px-1'>
                        <h5 className='text-end fw-bold m-0'>Total Puntos:</h5>
                        <h5 className='text-end fw-bold m-0'>{depor.nadadores[0]?.puntos.toFixed(2)}</h5>
                      </div>
                    </div>
                  </motion.div>
                ):(
                  <></>
                )
              })
            ):(
              <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{duration: 1}}
              className="w-100"
              >
                <div className='p-5 text-center'>
                  <img className='m-auto' style={{width: '230px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo prowebsports" />
                  <h1>¡Bienvenido!</h1>
                  <p>No tenemos top aún.</p>
                </div>
              </motion.div>
            )}
          </div>
        </TabPanel>
      </TabView>
      <Tooltip target=".speeddial-bottom-right .p-speeddial-action" position="left" />
      <SpeedDial className='position-fixed speeddial-bottom-right planilla' model={items} direction="up" transitionDelay={80} showIcon="pi pi-bars" hideIcon="pi pi-times" buttonClassName="p-button-danger" style={{bottom: '10px', right: '10px'}}/>
      <Dialog visible={pdfUrl ? true : false} maximizable style={{ width: '50em' }} breakpoints={{ '641px': '100%' }} modal className="p-fluid" onHide={() => setPdfUrl()}>
        <div className="field">
          <div className='mb-2 pdf-min pdf-max' style={{width: '100%'}}>
            <embed src={pdfUrl} width='100%' height='100%' type='application/pdf'/>
          </div>
        </div>
      </Dialog>
      <Dialog visible={dialogHistorial} style={{ width: '50em' }} breakpoints={{ '700px': '100%' }} header="Historial Deportivo" modal className="p-fluid" onHide={() => setDialogHistorial(false)}>
        <div className="field">
          {historialDeportista ?(
            <div className={`position-relative card p-1 col shadow card-torneo`} style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 12%, rgba(0, 212, 255, 1) 100%)'}}>
              <div className="w-100">
                <div className='d-flex justify-content-between'>
                  <div className='d-flex'>
                    <div>
                      {banderas(historialDeportista?.departamento, historialDeportista?.codePais)}
                    </div>
                    <p className='m-0 ms-2' style={{color: 'rgba(212, 212, 212, 1)'}}>{historialDeportista?.departamento}</p>
                  </div>
                  <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>PWS</p>
                </div>
                <div className='bg-light rounded-3 px-1 shadow position-relative'>
                  <Avatar className='position-absolute flex align-items-center justify-content-center mr-2' size='large' image={historialDeportista?.urlPhotoEq !== '' ? historialDeportista?.urlPhotoEq : null} label={(historialDeportista?.urlPhotoEq === '') && (historialDeportista?.nombreclub[0] + historialDeportista?.nombreclub[1])} style={{bottom: '0', right: '90px'}}/>
                  <img className='position-absolute' src={historialDeportista?.urlPhoto && historialDeportista?.urlPhoto !== '' ? historialDeportista?.urlPhoto : historialDeportista?.genero === 'Femenino' ? require('../img/img-dama.webp') : require('../img/img-varon.webp')} alt="foto deportista" style={{width: '80px', filter: 'drop-shadow(0 0 2px black) drop-shadow(0 0 1px white)', bottom: '0', right: '0'}}/>
                  <h4 className='card-title mt-1 mb-0 text-start'>{historialDeportista?.nombre}</h4>
                  <p className='m-0 text-start'><Tag severity={historialDeportista?.verificado === 'Verificado' ? 'primary' : 'danger'} value={historialDeportista?.verificado === 'Verificado' ? historialDeportista?.edad + ' Años Verificado' : historialDeportista?.edad + ' Años No Verificado'}></Tag></p>
                  <div className="d-flex justify-content-between">
                    <p className='m-0'>{historialDeportista?.genero}</p>
                  </div>
                </div>
                <p className='m-0 text-start' style={{color: 'rgba(212, 212, 212, 1)'}}>{historialDeportista?.nombreclub}</p>
                <p className='card-subtitle text-light'>{(historialDeportista?.genero === 'Masculino' ? '(M) ' : '(F) ') + historialDeportista?.categoria + ' Años ' + (historialDeportista?.genero === 'Masculino' ? 'M' : 'F')}</p>
                <hr className='m-0 text-light'/>
                {historialDeportista?.pruebas.length !== 0 ?(
                  historialDeportista?.pruebas.map((prue, indexPrue)=>{
                    return <div key={indexPrue}>
                      <div className='d-flex justify-content-center align-items-center' data-bs-toggle="collapse" href={`#collapseExample${indexPrue}${Math.round(prue.id)}`} role='button' aria-expanded="false" aria-controls={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                        <div className="text-center w-100">
                          <div className="d-flex justify-content-between">
                            <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{'Prueba #' + (prue.nPrueba)}</p>
                            <p className='m-0' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.prueba}</p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <p className='m-0 text-light'>{'Puesto #' + prue.puesto}{prue.puesto === 1 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" />: prue.puesto === 2 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /> :  prue.puesto === 3 ? <img style={{width: '25px'}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /> : ''}</p>
                            <p className='m-0 text-light'>{prue.tiempo === '0:0:0' ? 'NSP' : prue.tiempo === '61:0:0' ? 'DSC' : <label className="w-100 fw-bold d-flex flex-column text-end"><li style={{fontSize: '13px', textShadow: '0 0 8px black'}} className={manejoRendimiento(prue.record, prue.tiempo === '61:0:0' ? '0:0:0' : prue.tiempo) >= 0 ? 'pi pi-arrow-down text-success text-start' : 'pi pi-arrow-up text-danger text-start'}>{arreglarFormatoTiempo(manejoRendimiento(prue.record, prue.tiempo === '61:0:0' ? '0:0:0' : prue.tiempo))}</li>{arreglarTiempoEstandar(prue.tiempo)}</label>}</p>
                          </div>
                        </div>
                      </div>
                      <hr className='m-0 text-light'/>
                      <div className='collapse px-2' id={`collapseExample${indexPrue}${Math.round(prue.id)}`}>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Tiempo Inscrito:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{arreglarTiempoEstandar(prue.record)}</p>
                        </div>
                        <hr className='m-0 text-light'/>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>World Aquatics:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.tiempo !== '61:0:0' ? prue.tiempo !== '0:0:0' ? prue.puntos : '0' : '0' }</p>
                        </div>
                        <hr className='m-0 text-light'/>
                        <div className='d-flex justify-content-between'>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>Rendimiento Técnico:</p>
                          <p className='m-0 text-end' style={{color: 'rgba(212, 212, 212, 1)'}}>{prue.tiempo !== '61:0:0' ? prue.tiempo !== '0:0:0' ? prue.puntosWA : '0' : '0' }</p>
                        </div>
                      </div>
                      <hr className='m-0 text-light'/>
                    </div>
                  })
                ):(
                  <></>
                )}
              </div>
            </div>
          ):(
            <></>
          )}
        </div>
      </Dialog>
      <div className="modal fade" id="staticBackdrop1" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content" style={{borderRadius: '20px 0', background: 'linear-gradient(120deg, rgba(217, 255, 3, 0.8), rgba(0, 119, 255, 0.8), rgba(255, 0, 0, 0.8))'}}>
            <div className="modal-body p-0 position-relative">
              <button type="button" className="btn-close position-absolute end-0" data-bs-dismiss="modal" aria-label="Close" style={{top: '18px', paddingLeft: '12px', zIndex: 1000}}></button>
              <table className='w-100' style={{height: '180px'}}>
                <thead>
                  <tr style={{color: 'white'}}>
                    <th colSpan={2}><img className='ps-2' src={require('../img/img_logo.png')} alt="logo pws" style={{width: '130px'}}/></th>
                    <th style={{fontSize: '38px', textAlign: 'center'}} colSpan={2}>
                      {`${resultados[resultados.length - 1] ? resultados[resultados.length - 1].categoria : ''} / ${resultados[resultados.length - 1] ? resultados[resultados.length - 1].prueba.prueba: ''}`}
                      <hr className='m-0'/>
                      <div className="marqueePws" style={{width: '77vw'}}>
                        <div className="marquee__innerPws">
                          <span style={{fontSize:'40px'}}>
                            {`¡BIENVENIDOS! AL GRAN EVENTO ${torneoEspecifico.titulo} - ${datosAdmin.nombre}`}
                          </span>
                          <span style={{fontSize:'40px'}}>
                            {`¡BIENVENIDOS! AL GRAN EVENTO ${torneoEspecifico.titulo} - ${datosAdmin.nombre}`}
                          </span>
                          <span style={{fontSize:'40px'}}>
                            {`¡BIENVENIDOS! AL GRAN EVENTO ${torneoEspecifico.titulo} - ${datosAdmin.nombre}`}
                          </span>
                        </div>
                      </div>
                    </th>
                    <th><img className='pe-2' src={require('../img/pwsmascota-derecha.png')} alt="logo pws" style={{width: '150px', filter: "drop-shadow(-1px 1px 2px black)"}}/></th>
                  </tr>
                </thead>
                <thead>
                  <tr className='bg-light'>
                    <th style={{fontSize: '25px', fontFamily: 'Winky Sans'}}>Psto</th>
                    <th style={{fontSize: '25px', fontFamily: 'Winky Sans'}}>Equipo</th>
                    <th style={{fontSize: '25px', fontFamily: 'Winky Sans'}} colSpan={2}>Deportista</th>
                    <th style={{fontSize: '25px', fontFamily: 'Winky Sans'}}>Tiempo</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    resultados[resultados.length - 1] ?(
                    resultados[resultados.length - 1].nadadores.slice(0, parseInt(torneoEspecifico.carril)).map((nadador, indexNadador)=>{
                    return <motion.tr key={indexNadador}
                    initial={{ x: -3000, opacity: 0}}
                    animate={{ x: animateList ? -3000 : 0.1, opacity: animateList ? 0 : 1}}
                    style={{borderRadius: '20px 0', boxShadow: '0 3px 8px black', zIndex: `1.${indexNadador}`}}
                    transition={{ duration: 0.5, delay: `0.${indexNadador}`}}
                    >
                      {indexNadador === 0 ? <td className='submit' style={{width: '65px', borderRadius: '20px 0 0 0'}}><img style={{width: '55px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-1.png")} alt="medalla primer lugar" /></td> : indexNadador === 1 ? <td className='submit' style={{borderRadius: '20px 0 0 0'}}><img style={{width: '55px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-2.png")} alt="medalla segundo lugar" /></td> :  indexNadador === 2 ? <td className='submit' style={{borderRadius: '20px 0 0 0'}}><img style={{width: '55px', filter: "drop-shadow(-1px 1px 2px black)"}} src={require("../img/icon-medalla-3.png")} alt="medalla tercer lugar" /></td> : <td className='submit text-warning' style={{fontSize: '30px', borderRadius: '20px 0 0 0'}}>{indexNadador + 1}</td>}
                      <td className='ps-2 submit' style={{width: '150px', fontSize: '30px', fontFamily: 'Poppins', textAlign: 'start'}}>{nadador.club}</td>
                      <td className='ps-1 pe-1 submit' style={{width: '50px', textAlign: 'start'}}>{banderas(nadador.departamento, nadador.codePais)}</td>
                      <td className='ps-2 submit' style={{fontSize: '30px', fontFamily: 'Poppins', textAlign: 'start'}}>{nadador.nombre}</td>
                      <td className='ps-2 submit' style={{fontSize: '29px', fontFamily: 'Fira Sans Extra Condensed', borderRadius: '0 0 20px 0', letterSpacing: '2px'}}>{nadador.tiempo === '0:0:0' ? 'NSP' : nadador.tiempo === '61:0:0' ? 'DSC' : `${arreglarTiempoEstandar(nadador.tiempo)}`}</td>
                    </motion.tr>
                  })):(
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className='w-100 bg-light d-flex justify-content-between' style={{fontSize: '18px', fontFamily: 'Winky Sans', borderRadius: '20px 0 20px 0', letterSpacing: '2px', boxShadow: '0 3px 8px black'}}>
                <p className='m-0 p-1 ps-3'>PROWEBSPORTS</p>
                <p className='m-0 p-1 pe-3'>www.prowebsports.com.co</p> 
              </div>
            </div>
          </div>
          <div className="bgResultados"></div>
          <div className="bgResultados bg2"></div>
          <div className="bgResultados bg3"></div>
        </div>
      </div>
    </div>
  );
}

export default ResultadosTiempos;